import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const ServicesSection = () => {
  const { t } = useTranslation();

  const services = [
    {
      icon: 'ri-heart-pulse-line',
      title: t('services.therapeutic'),
      description: t('services.therapeuticDesc'),
      image: 'https://static.readdy.ai/image/4f8e52dde3dda7b1227768a95bdc6f97/541384ccda4e013cd2acbad78ac2dd3e.jpeg',
      link: '/services/therapeutic'
    },
    {
      icon: 'ri-tooth-line',
      title: t('services.orthopedic'),
      description: t('services.orthopedicDesc'),
      image: 'https://static.readdy.ai/image/4f8e52dde3dda7b1227768a95bdc6f97/868ffa40232e7275983e8685e42ebbe4.jpeg',
      link: '/services/orthopedic'
    },
    {
      icon: 'ri-surgical-mask-line',
      title: t('services.surgery'),
      description: t('services.surgeryDesc'),
      image: 'https://public.readdy.ai/ai/img_res/0c0d3242b7e7f127c54aebf5d04a54d2.jpg',
      link: '/services/surgery'
    },
    {
      icon: 'ri-capsule-line',
      title: t('services.implantation'),
      description: t('services.implantationDesc'),
      image: 'https://readdy.ai/api/search-image?query=dental%20implantation%20procedure%20room%20with%20advanced%20technology%20equipment%20clean%20white%20interior%20professional%20atmosphere%20minimalist%20design%20dental%20implants%20display&width=600&height=400&seq=service4&orientation=landscape',
      link: '/services/implantation'
    },
    {
      icon: 'ri-contrast-line',
      title: t('services.orthodontics'),
      description: t('services.orthodonticsDesc'),
      image: 'https://readdy.ai/api/search-image?query=orthodontic%20treatment%20room%20with%20braces%20models%20and%20dental%20alignment%20tools%20clean%20white%20interior%20professional%20atmosphere%20minimalist%20design%20modern%20equipment&width=600&height=400&seq=service5&orientation=landscape',
      link: '/services/orthodontics'
    },
    {
      icon: 'ri-shield-check-line',
      title: t('services.prevention'),
      description: t('services.preventionDesc'),
      image: 'https://static.readdy.ai/image/4f8e52dde3dda7b1227768a95bdc6f97/720f7441cc9607aa9521c57478824eab.jpeg',
      link: '/services/prevention'
    }
  ];

  return (
    <section id="services" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            {t('services.title')}
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            {t('services.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {services.map((service, index) => (
            <Link 
              key={index}
              to={service.link}
              className="group relative bg-white rounded-xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 cursor-pointer"
            >
              <div className="relative h-64 overflow-hidden">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900/90 via-gray-900/50 to-transparent"></div>
                <div className="absolute inset-0 bg-teal-600/0 group-hover:bg-teal-600/20 transition-colors duration-500"></div>
              </div>
              
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-0 group-hover:translate-y-0 transition-transform duration-300">
                <div className="flex items-center mb-3">
                  <div className="w-12 h-12 bg-teal-500 rounded-lg flex items-center justify-center mr-4">
                    <i className={`${service.icon} text-2xl text-white`}></i>
                  </div>
                  <h3 className="text-xl font-semibold">
                    {service.title}
                  </h3>
                </div>
                <p className="text-sm text-gray-200 leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100">
                  {service.description}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center">
          <a 
            href="#contact"
            className="inline-block px-8 py-3 bg-teal-600 text-white text-base font-medium rounded-lg hover:bg-teal-700 transition-colors duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            {t('services.bookButton')}
          </a>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;